
/**
 * Model for Outrights
 */
import DateFilterService from '../../../services/date-filter-service';
import OutrightOutcomeModel from './model-outright-outcome';
export default class OutrightModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Outright ID
     * @type {number}
     */
    this.id = data.outid;
    /**
     * Category id
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
     * Tournament id
     * @type {number}
     */
    this.tournamentId = data.tid;
    /**
     * Tournament Tab ids
     * @type {number}
     */
    this.tournamentTabIds = data.ttids;
    /**
     * Sport id
     * @type {number}
     */
    this.sportId = data.sid || 0;
    /**
     * Outcome id
     * @type {number}
     */
    this.outcomeId = data.oid;
    /**
     * Outright EndDate time string
     * @type {string}
     */
    this.time = DateFilterService.localDate(
      data.ed,
      'time',
      '',
      APP_SETTINGS.formatting.shortTimeFormat,
    );
    /**
     * Outright EndDate date string
     */
    this.date = DateFilterService.localDate(
      data.ed,
      'date',
      APP_SETTINGS.formatting.fullDateFormat,
      '',
    );
    this.APIendDate = data.ed;
    /**
     * Outright EndDate in local timezone
     * @type {string}
     */
    this.endDate = DateFilterService.localDate(
      data.ed,
      '',
      APP_SETTINGS.formatting.fullDateFormat,
      APP_SETTINGS.formatting.shortTimeFormat,
    );
    /**
     * Outright suspend date
     * @type {string}
     */
    this.bettingDate = DateFilterService.localDate(
      data.evd,
      'date',
      APP_SETTINGS.formatting.fullDateFormat,
      '',
    );
    this.APIbettingEndDate = data.evd;
    /**
     * Outright suspend date in local timezone
     * @type {string}
     */
    this.bettingEndDate = DateFilterService.localDate(
      data.evd,
      '',
      APP_SETTINGS.formatting.fullDateFormat,
      APP_SETTINGS.formatting.shortTimeFormat,
    );
    /**
     * Info Box
     * @type {string}
     */
    this.infoBox = data.ib;
    /**
     * Outright Name
     * @type {string}
     */
    this.name = data.n;
    /**
     * @type {OutrightOutcomeModel[]}
     */
    const outcomes = (data.o || []).map(o => new OutrightOutcomeModel(o));
    /**
     * Outcomes array
     */
    this.outcomes = outcomes;
    /**
     * Flag if outright has only one outcome
     */
    this.isDirectOutright = outcomes.length === 1;
    /**
     * Suspended outright
     * @type {boolean}
     */
    this.outrightSuspended = data.osu;
    /**
     * @type {string}
     */
    this.categoryName = data.cn;
    /**
    * @type {string}
    */
    this.titleName = data.tn;
    /**
    * @type {string}
    */
    this.sportName = data.sn;
  }
}
